import { StaffLicenseEditModel } from "./staff.license.edit.model";

export class StaffLicenseOverviewModel extends StaffLicenseEditModel {
    public staffName: string;
    public lastRenewed: string;
}